import './StatBar.css';

export default function StatBar({
  value,
  maxValue,
  colorMode = 'single',
  color,
  teamClass,
  label,
  icon,
  size = 'normal',
  className = '',
  borderColor,
  fillColor,        // Override color del fill
  textColor,        // Override color del texto
  textStrokeColor   // Color del stroke (si no se pasa = sin stroke)
}) {
  // Validación
  if (value === undefined || maxValue === undefined) {
    throw new Error('[StatBar] value and maxValue are required');
  }

  const percentage = Math.max(0, Math.min(100, (value / maxValue) * 100));

  // Determinar color del fill (fillColor override gana)
  const getFillColor = () => {
    if (fillColor) return fillColor; // Override explícito
    if (colorMode === 'single') return color;
    if (colorMode === 'team') return `var(--team-color-${teamClass})`;
    // tier mode - uses rating colors (same as ShopStatDisplay)
    // Special case: 1 HP is always critical (red) unless maxValue is also 1
    if (value === 1 && maxValue > 1) return 'var(--color-rating-low)';
    if (percentage > 50) return 'var(--color-rating-high)';
    if (percentage > 25) return 'var(--color-rating-avg)';
    return 'var(--color-rating-low)';
  };

  const computedFillColor = getFillColor();

  // Determinar color del texto (textColor override gana)
  const getTextColor = () => {
    if (textColor) return textColor; // Override explícito
    if (colorMode === 'tier') return computedFillColor; // Mismo que fill
    return '#fff'; // Default blanco para single/team
  };

  // Determinar stroke del texto (textStrokeColor override gana)
  const getTextStroke = () => {
    if (textStrokeColor) return textStrokeColor; // Override explícito
    if (colorMode === 'tier') return '#000'; // Negro por defecto en tier
    return null; // Sin stroke para single/team
  };

  const strokeColor = getTextStroke();
  const textStyle = {
    color: getTextColor(),
    ...(strokeColor && {
      textShadow: `-1px -1px 0 ${strokeColor}, 1px -1px 0 ${strokeColor}, -1px 1px 0 ${strokeColor}, 1px 1px 0 ${strokeColor}`
    })
  };

  return (
    <div
      className={`stat-bar stat-bar-${size} ${className}`}
      style={borderColor ? { borderColor } : undefined}
    >
      <div
        className="stat-bar-fill"
        style={{ width: `${percentage}%`, backgroundColor: computedFillColor }}
      />
      <span className="stat-bar-text" style={textStyle}>
        {value}/{maxValue}{label && ` ${label}`}
        {icon}
      </span>
    </div>
  );
}
